(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["media-lightbox"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('media-lightbox')) return;

    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class MediaLightbox extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.track = this.querySelector('[data-lightbox-track]');
        this.counter = this.querySelector('[data-lightbox-current]');
        this.prev = this.querySelector('[data-lightbox-prev]');
        this.next = this.querySelector('[data-lightbox-next]');
        this.thumbs = [...this.querySelectorAll('[data-lightbox-thumb]')];
        this.count = this.track ? this.track.children.length : 0;
        this.index = 0;
        if (!this.dialog || !this.track) return;

        this.querySelector('[data-lightbox-close]')?.addEventListener('click', () => this.dialog.close());
        this.prev?.addEventListener('click', () => this.goTo(this.index - 1));
        this.next?.addEventListener('click', () => this.goTo(this.index + 1));
        this.thumbs.forEach((thumb) =>
          thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.lightboxThumb)))
        );

        // Clicking the empty area around an image (or the backdrop) closes it.
        this.dialog.addEventListener('click', (event) => {
          const t = event.target;
          if (t === this.dialog || (t instanceof Element && t.matches('.media-lightbox__slide'))) this.dialog.close();
        });

        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.index + 1);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.index - 1);
          }
        });

        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('media-lightbox-open');
          this.opener?.focus?.({ preventScroll: true });
        });

        let raf = 0;
        this.track.addEventListener(
          'scroll',
          () => {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() => this.sync());
          },
          { passive: true }
        );
      }

      open(index, opener) {
        this.opener = opener;
        document.documentElement.classList.add('media-lightbox-open');
        this.dialog.showModal();
        this.goTo(index, true);
        // Focus the dialog itself (not the close button) so no focus ring flashes
        // on open for mouse/touch users; Tab still reaches every control.
        this.dialog.focus({ preventScroll: true });
      }

      goTo(index, instant = false) {
        const i = Math.max(0, Math.min(this.count - 1, index));
        this.track.scrollTo({
          left: i * this.track.clientWidth,
          behavior: instant || reduceMotion() ? 'instant' : 'smooth',
        });
        this.setIndex(i);
      }

      sync() {
        const w = this.track.clientWidth;
        if (!w) return;
        this.setIndex(Math.round(this.track.scrollLeft / w));
      }

      setIndex(i) {
        this.index = i;
        if (this.counter) this.counter.textContent = String(i + 1);
        if (this.prev) this.prev.disabled = i <= 0;
        if (this.next) this.next.disabled = i >= this.count - 1;
        this.thumbs.forEach((thumb, n) => {
          if (n === i) {
            thumb.setAttribute('aria-current', 'true');
            thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }
    }

    customElements.define('media-lightbox', MediaLightbox);

    // Gallery slides carry data-lightbox-open="<index>" and data-lightbox-target.
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const trigger = event.target.closest('[data-lightbox-open]');
      if (!trigger) return;
      const box = document.getElementById(trigger.getAttribute('data-lightbox-target') || '');
      if (!box || typeof box.open !== 'function') return;
      event.preventDefault();
      box.open(Number(trigger.getAttribute('data-lightbox-open')) || 0, trigger);
    });

    // Keyboard access: gallery slides aren't focusable buttons, so Enter/Space
    // on a focused slide opens the lightbox as well.
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      if (!(event.target instanceof Element) || !event.target.matches('[data-lightbox-open]')) return;
      event.preventDefault();
      event.target.click();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["whatsapp-float"] && !Shopify.designMode) return;
  try {
    (() => {
    // Keeps --whatsapp-lift equal to the fixed buy bar's height plus its gap to
    // the bottom of the screen (offsetHeight ignores the bar's slide transform,
    // so this is right even mid-animation). Only pages with the bar need it.
    const measure = () => {
      const bar = document.querySelector('.sticky-add-to-cart__bar');
      if (!bar) return;
      const gap = parseFloat(getComputedStyle(bar).bottom) || 0;
      document.documentElement.style.setProperty('--whatsapp-lift', `${Math.ceil(bar.offsetHeight + gap)}px`);
    };
    const start = () => {
      const bar = document.querySelector('.sticky-add-to-cart__bar');
      if (!bar) return;
      measure();
      new ResizeObserver(measure).observe(bar);
      new MutationObserver(measure).observe(bar, { attributes: true, attributeFilter: ['data-stuck'] });
      window.addEventListener('resize', measure, { passive: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
